import { CategoryEnum, CategoryType, GeoPointType, PaginationArgsType } from '@/@types';
import { gql } from './_utils';
import { NamespaceArgsType } from './@types';

type ProductFilterType = {
  subcategories?: { label: 'genre' | 'provider'; values: string[] }[];
  location?: GeoPointType;
};

type ProductOptionsType = { filters?: ProductFilterType; pagination?: PaginationArgsType };

type OptionsType = {
  products?: ProductOptionsType;
  location?: GeoPointType;
};

export const Category = ({ graphqlRequest }: NamespaceArgsType) => {
  return {
    get: async <T extends CategoryEnum = any>(category: CategoryType<T>, { products }: OptionsType = {}) => {
      return graphqlRequest<{ Category: { get?: CategoryType<T> } }>({
        query: gql`
          query GetCategory(
            $id: ID!
            $productFilters: CategoryProductFilter
            $productPagination: PaginationProductSortByArgs
            $withProduct: Boolean = false
          ) {
            Category {
              get(id: $id) {
                id
                name
                products(filters: $productFilters, pagination: $productPagination) @include(if: $withProduct) {
                  edges {
                    node {
                      id
                      name
                      image
                      description
                      popularity
                      media {
                        type
                        source
                      }
                      category {
                        id
                        name
                      }
                      extraInfo {
                        ... on Movie {
                          ratings {
                            source
                            value
                            unit
                            total
                            votes
                          }
                          preview {
                            source
                            id
                          }
                        }
                        ... on Serie {
                          ratings {
                            source
                            value
                            unit
                            total
                            votes
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          id: category.name,
          productFilters: products?.filters,
          productPagination: products?.pagination,
          withProduct: !!products,
        },
      });
    },
  };
};
